import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Search } from 'lucide-react';

interface MessageSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export const MessageSearch: React.FC<MessageSearchProps> = ({
  value,
  onChange,
}) => {
  return (
    <TextField
      fullWidth
      placeholder="Search messages by case number or title..."
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search size={20} />
          </InputAdornment>
        ),
      }}
      sx={{
        maxWidth: 400,
        '& .MuiOutlinedInput-root': {
          borderRadius: 2,
        },
      }}
    />
  );
};